import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import Placeholder from '@atlaskit/react-ufo/placeholder';
import {
	tenantContextProviderQuery as Query,
	TenantContextProvider,
	type TenantContextProviderQuery as tenantContextProviderQuery,
} from '@dev-agents/tenant-context';
import { useEffect } from 'react';
import { useQueryLoader } from 'react-relay';

import { ErrorBoundary } from '../common/error-boundary';
import { envType } from '../common/types';
import { getEnvType } from '../utils';
import { AnalyticsWebClientProvider } from '../utils/analytics/context';

import { App } from './App';

export const AppWithTenantContext = () => {
	const [queryRef, loadQuery] = useQueryLoader<tenantContextProviderQuery>(Query);

	const hostName =
		getEnvType() === envType.LOCAL ? process.env.REMOTE_DOMAIN || '' : window.location.hostname;

	useEffect(() => {
		loadQuery({
			hostNames: [hostName],
		});
	}, [loadQuery, hostName]);

	return (
		<ErrorBoundary>
			<Placeholder name="dev-agents-tenant-context">
				{queryRef ? (
					<TenantContextProvider queryRef={queryRef}>
						<AnalyticsWebClientProvider>
							<App />
						</AnalyticsWebClientProvider>
					</TenantContextProvider>
				) : (
					<UFOLoadHold name="dev-agents-auth-context" />
				)}
			</Placeholder>
		</ErrorBoundary>
	);
};
